import type { StaticImageData } from 'next/image'
import Image from 'next/image'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import testimonial1 from './images/testimonial-1.webp'
import testimonial2 from './images/testimonial-2.webp'
import testimonial3 from './images/testimonial-3.webp'
import testimonial4 from './images/testimonial-4.webp'
import testimonial5 from './images/testimonial-5.webp'
import testimonial6 from './images/testimonial-6.webp'
import testimonial7 from './images/testimonial-7.webp'
import { Marquee } from './marquee'

type Tile =
  | { kind: 'quote'; name: string; role: string; quote: string }
  | { kind: 'photo'; src: StaticImageData; alt: string }

const ROW_ONE: Tile[] = [
  {
    kind: 'quote',
    name: 'Iis Delis',
    role: 'Guru SD Negeri Serang 10',
    quote:
      'Salah satu momen bermakna yang saya alami adalah ketika seorang siswa yang biasanya pendiam akhirnya berani mengemukakan pendapatnya tentang cerita buku yang dibaca di depan teman-temannya.',
  },
  { kind: 'photo', src: testimonial1, alt: 'Foto kelas PiBo' },
  {
    kind: 'quote',
    name: 'Azqia Wardatulummah',
    role: 'Guru SDN Sindangsari',
    quote:
      'Saya jadi paham bahwa setiap anak punya ‘gerbang’ literasi yang berbeda, dan tugas guru adalah membantu mereka menemukannya.',
  },
  {
    kind: 'quote',
    name: 'Titi Suryanti',
    role: 'Guru SD Negeri Sepring',
    quote:
      'Bagi saya, pengalaman ini menjadi pengingat untuk selalu menghadirkan pembelajaran yang sederhana, dekat dengan kehidupan sehari-hari, dan bermanfaat jangka panjang bagi siswa.',
  },
  { kind: 'photo', src: testimonial2, alt: 'Foto kelas PiBo' },
  { kind: 'photo', src: testimonial3, alt: 'Foto kelas PiBo' },
]

const ROW_TWO: Tile[] = [
  { kind: 'photo', src: testimonial4, alt: 'Foto kelas PiBo' },
  { kind: 'photo', src: testimonial5, alt: 'Foto kelas PiBo' },
  {
    kind: 'quote',
    name: 'Fandi Ahmad',
    role: 'Guru SD Negeri Serang 10',
    quote:
      'Awalnya ada orang tua yang ragu, tapi setelah melihat anaknya membaca 1–2 jam sehari di PiBo, mereka jadi mendukung penuh. Sampai ada yang bilang kalau anaknya membantu ibunya mendongengkan adiknya yang masih kecil.',
  },
  { kind: 'photo', src: testimonial6, alt: 'Hasil karya murid' },
  { kind: 'photo', src: testimonial7, alt: 'Foto kelas PiBo' },
  {
    kind: 'quote',
    name: 'Dewi Anita',
    role: 'SD Taman',
    quote:
      'Saya dapat berkolaborasi dengan wali murid… banyak pengalaman selain membaca bersama yaitu anak-anak berdiskusi dan terlibat aktif',
  },
]

function TileView({ tile }: { tile: Tile }) {
  if (tile.kind === 'photo') {
    return (
      <div className='bg-grey-20 relative min-h-50 w-45 shrink-0 overflow-hidden rounded-2xl md:min-h-60 md:w-60'>
        <Image src={tile.src} alt={tile.alt} fill sizes='240px' className='object-cover' loading='lazy' />
      </div>
    )
  }

  return (
    <div className='bg-neutral-white border-grey-20 flex min-h-50 w-70 shrink-0 flex-col gap-2 rounded-2xl border p-4 md:min-h-60 md:w-90 md:p-5'>
      <span className={typographyVariants({ variant: 'title-md' })}>{tile.name}</span>
      <span className={cn(typographyVariants({ variant: 'body-md' }), 'text-navy-60')}>{tile.role}</span>
      <p className={cn(typographyVariants({ variant: 'body-md' }), 'mt-1')}>{tile.quote}</p>
    </div>
  )
}

/** Two rows of teacher quotes and class photos, running in opposite directions. */
export function Testimonials() {
  return (
    <div className='flex w-full flex-col gap-4'>
      <Marquee>
        {ROW_ONE.map((tile, index) => (
          <TileView key={index} tile={tile} />
        ))}
      </Marquee>
      <Marquee reverse>
        {ROW_TWO.map((tile, index) => (
          <TileView key={index} tile={tile} />
        ))}
      </Marquee>
    </div>
  )
}
